import { useContext } from 'react';

import withAuth from 'hocs/withAuth/withAuth';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { SpecialistContext } from 'context';
import { ProgramsContext } from 'context/ProgramsContext';
import { useRequest, useOnInit } from 'hooks';
import { getPrograms } from 'services/programs';

import { ProgramCard } from 'components';

import * as S from './styles';

const ContentLibrary: React.FC = () => {
  const { programs, setPrograms } = useContext(ProgramsContext);
  const request = useRequest();
  const { specialistInfo } = useContext(SpecialistContext);
  const navigate = useNavigate();

  useOnInit(() => {
    if (!programs) {
      const fetchProgramsList = async () => {
        request.setLoading();
        try {
          const programsList = await getPrograms();
          setPrograms(programsList);
          request.setSuccess();
        } catch (e) {
          request.setError((e as Error).message);
        }
      };

      fetchProgramsList();
    }

    if (specialistInfo?.geoCode && specialistInfo.geoCode !== 'BR') {
      navigate('/care-provider/info');
    }
  });

  return (
    <S.Container data-testid="contentLibraryContainer">
      <S.HeaderInfoContainer>
        <S.HeaderLabel data-testid="contentLibraryTitle">
          <FormattedMessage id="CONTENT_LIBRARY.PAGE.TITLE" />
        </S.HeaderLabel>
      </S.HeaderInfoContainer>
      <S.Divisor />

      <S.DiscoveryBannerContainer data-testid="contentLibraryDiscoveryBanner">
        <S.DiscoveryBannerTitle>
          <FormattedMessage id="CONTENT_LIBRARY.DISCOVER_BANNER.TITLE" />
        </S.DiscoveryBannerTitle>
        <S.DiscoveryBannerDescription>
          <FormattedMessage id="CONTENT_LIBRARY.DISCOVER_BANNER.DESCRIPTION" />
        </S.DiscoveryBannerDescription>
      </S.DiscoveryBannerContainer>

      <S.ProgramsListContainer>
        {request.isLoading() && (
          <>
            <S.SkeletonCard />
            <S.SkeletonCard />
            <S.SkeletonCard />
          </>
        )}
        {programs?.map(program => (
          <ProgramCard
            key={program.id}
            id={program.id}
            titleKey={program.titleKey}
            description={program.description}
            createdAt={program.createdAt}
            programTopics={program.programTopics}
          />
        ))}
      </S.ProgramsListContainer>
    </S.Container>
  );
};

export default withAuth(ContentLibrary);
